import { render, staticRenderFns } from "./UserServicepointsTable.vue?vue&type=template&id=178fd7dc&scoped=true"
import script from "./UserServicepointsTable.vue?vue&type=script&lang=ts"
export * from "./UserServicepointsTable.vue?vue&type=script&lang=ts"
import style0 from "./UserServicepointsTable.vue?vue&type=style&index=0&id=178fd7dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178fd7dc",
  null
  
)

export default component.exports